import script from "./QBottomPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./QBottomPanel.vue?vue&type=script&setup=true&lang=js"

import "./QBottomPanel.vue?vue&type=style&index=0&id=7edf5fc2&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend-demo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7edf5fc2"]])

export default __exports__